// @ts-nocheck

const motives = {
  default: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      marginTop: 3,
      color: '#337ab7',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      maxHeight: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      color: state.value === '' ? '#999999' : '#000000',
      cursor: 'pointer',
      minHeight: 30,
      '&:hover': {
        backgroundColor: '#DFE8F2',
      },
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 3,
      minHeight: 30,
      height: 30,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.value === '' ? '#999999' : '#000000',
    }),
  },
  filter: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      marginTop: 3,
      color: '#337ab7',
      cursor: 'pointer',
      textTransform: 'uppercase',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      maxHeight: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      color: state.value === '' ? '#999999' : '#000000',
      cursor: 'pointer',
      minHeight: 30,
      fontSize: 12,
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: '#DFE8F2',
      },
    }),
    control: (provided, { isFocused }) => ({
      ...provided,
      borderRadius: 3,
      minHeight: 30,
      height: 30,
      cursor: 'pointer',
      fontSize: 12,
      textTransform: 'uppercase',
      borderColor: isFocused ? '#DFE8F2' : '#000000',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.value === '' ? '#999999' : '#000000',
      cursor: 'pointer',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#000000',
      cursor: 'pointer',
    }),
    valueContainer: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  },
  disabled: {
    menu: (provided) => ({
      ...provided,
      borderRadius: 3,
      marginTop: 3,
      color: '#337ab7',
      cursor: 'pointer',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      maxHeight: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      backgroundColor: state.isSelected ? '#337ab7' : '#ffffff',
      color: state.value === '' ? '#999999' : '#000000',
      cursor: 'pointer',
      minHeight: 33,
      fontSize: 12,
      '&:hover': {
        backgroundColor: '#DFE8F2',
      },
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 3,
      borderColor: '#c7c7c7',
      backgroundColor: '#c7c7c7',
      color: '#ffffff',
      minHeight: 30,
      height: 30,
      fontSize: 12,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.value === '' ? '#999999' : '#000000',
      cursor: 'pointer',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    valueContainer: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#000000',
      cursor: 'pointer',
    }),
  },
  user: {
    menu: (provided) => ({
      ...provided,
      cursor: 'pointer',
      textTransform: 'uppercase',
    }),
    option: (provided) => ({
      ...provided,
      cursor: 'pointer',
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: '#DFE8F2',
      },
    }),
    control: (provided) => ({
      ...provided,
      cursor: 'pointer',
      textTransform: 'uppercase',
      fontSize: '1.2rem',
    }),
    singleValue: (provided) => ({
      ...provided,
      cursor: 'pointer',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      cursor: 'pointer',
    }),
  },
};

export type SelectMotives = keyof typeof motives;

const pickMotive = (motive: SelectMotives) => motives[motive];

export { pickMotive };
